/**
 * Public product brand — ShopperZulu front-of-house;
 * "The Better Xchange" is the motto on the tablet landing.
 */
export const PRODUCT_BRAND = {
  name: 'ShopperZulu',
  motto: 'The Better Xchange',
  shortMark: 'SZ',
};

export default PRODUCT_BRAND;
